// src/translations/translations.js
import { useLanguage } from '../contexts/LanguageContext';

export const translations = {
  es: {
    // Hero Section
    hero: {
      title: "Recursero regional de materiales de AMI",
      description: "Explorá una plataforma con más de 50 recursos educativos desarrollados por organizaciones chequeadoras miembros de LatamChequea de distintos países de América Latina como Argentina, Bolivia, Colombia, Guatemala, México y Uruguay. Incluye actividades didácticas, juegos, videos, podcast, tutoriales y materiales pedagógicos pensados para fortalecer el pensamiento crítico y promover la Alfabetización Mediática e Informacional (AMI)."
    },
    // Filters
    filters: {
      searchPlaceholder: "Buscar recursos...",
      clearFilters: "Limpiar filtros",
      type: "Tipo",
      theme: "Tema", 
      organization: "Organización",
      country: "País",
      anyOrganization: "Cualquier organización",
      anyCountry: "Cualquier país",
      clearSelection: "Limpiar selección",
      selected: "seleccionados"
    },
    // Resource Card
    card: {
      visitResource: "Visitar recurso",
      readMore: "Leer más",
      readLess: "Leer menos"
    },
    // Funded By Section
    fundedBy: {
      title: "Financiado por",
      altText: "Unión Europea",
      projectText: "Este recursero es parte del proyecto \"Promover la información confiable y luchar contra la desinformación en América Latina\", coordinado por Chequeado a nivel regional con foco en Chile, México y Uruguay, y financiado por la Unión Europea. Su contenido es responsabilidad exclusiva de LatamChequea y no refleja necesariamente los puntos de vista de la Unión Europea."
    },
    // General
    general: {
      noResults: "No se encontraron recursos que coincidan con los criterios de búsqueda.",
      loading: "Cargando...",
      error: "Error:"
    }
  },
  en: {
    // Hero Section
    hero: {
      title: "Regional Resource Hub for MIL Materials",
      description: "Explore a platform featuring more than 50 educational resources developed by organizations from different Latin American countries, such as Argentina, Bolivia, Colombia, Guatemala, Mexico, and Uruguay. It includes learning activities, games, videos, podcasts, tutorials, and teaching materials designed to strengthen critical thinking and promote Media and Information Literacy (MIL)."
    },
    // Filters
    filters: {
      searchPlaceholder: "Search resources...",
      clearFilters: "Clear filters",
      type: "Type",
      theme: "Topic",
      organization: "Organization",
      country: "Country",
      anyOrganization: "Any organization",
      anyCountry: "Any country", 
      clearSelection: "Clear selection",
      selected: "selected"
    },
    // Resource Card
    card: {
      visitResource: "Visit resource",
      readMore: "Read more",
      readLess: "Read less"
    },
    // Funded By Section
    fundedBy: {
      title: "Funded by",
      altText: "European Union",
      projectText: "This resource hub is part of the project \"Promoting reliable information and combating disinformation in Latin America\", coordinated regionally by Chequeado with a focus on Chile, Mexico, and Uruguay, and funded by the European Union. The content is the sole responsibility of LatamChequea and does not necessarily reflect the views of the European Union."
    },
    // General
    general: {
      noResults: "No resources found matching the search criteria.",
      loading: "Loading...",
      error: "Error:"
    }
  },
  pt: {
    // Hero Section
    hero: {
      title: "Repositório regional de materiais de AMI",
      description: "Explore uma plataforma com mais de 50 recursos educacionais desenvolvidos por organizações de diferentes países da América Latina, como Argentina, Bolívia, Colômbia, Guatemala, México e Uruguai. Inclui atividades didáticas, jogos, vídeos, podcasts, tutoriais e materiais pedagógicos pensados para fortalecer o pensamento crítico e promover a Alfabetização Midiática e Informacional (AMI)."
    },
    // Filters
    filters: {
      searchPlaceholder: "Buscar recursos...",
      clearFilters: "Limpar filtros",
      type: "Tipo",
      theme: "Tema",
      organization: "Organização",
      country: "País",
      anyOrganization: "Qualquer organização",
      anyCountry: "Qualquer país",
      clearSelection: "Limpar seleção",
      selected: "selecionados"
    },
    // Resource Card
    card: {
      visitResource: "Visitar recurso",
      readMore: "Ler mais",
      readLess: "Ler menos"
    },
    // Funded By Section
    fundedBy: {
      title: "Financiado por",
      altText: "União Europeia",
      projectText: "Este repositório faz parte do projeto \"Promover informações confiáveis e combater a desinformação na América Latina\", coordenado regionalmente pelo Chequeado com foco no Chile, México e Uruguai, e financiado pela União Europeia. O conteúdo é de responsabilidade exclusiva da LatamChequea e não reflete necessariamente os pontos de vista da União Europeia."
    },
    // General
    general: {
      noResults: "Nenhum recurso encontrado que corresponda aos critérios de pesquisa.",
      loading: "Carregando...",
      error: "Erro:"
    }
  }
};

// Hook para usar las traducciones
export const useTranslations = () => {
  const { currentLanguage } = useLanguage();
  return translations[currentLanguage] || translations.es;
};